//#################### Path :: app/scripts/menu.js//####################
var navContent = $('[data-menu="navContent"]');
var navTrigger = $('[data-menu="navTrigger"]');
var navSearch = $('[data-menu="navSearch"]');

var startSearchBox = $('#startSearchBox');
var destSearchBox = $('#destSearchBox');
var routeSearchForm = $('#routeSearchForm');

var destHeader = $('.header-infos.left');
$(function () {

    if (document.getElementById('truckMap')) {
        if (!fromRefresh) {
            navSearchOpen();
            popUp('modals/disclaimer', getRestrictions);
        } else {
            getRestrictions();
        }
    }

    destHeader.click(function () {
        centerOnDestination();
    });
    $('.startCompass').click(function () {
        setPositionAsStart(currentPositionMarker.getPosition());

    });

    $(":text").click(function () {
        $(this).select();
    });


    navTrigger.click(function () {
        if ($(this).hasClass('clicked')) {
            navTriggerClose();
        } else {
            navSearchClose(navSearch);
            directionsClose();
            //optionsClose();
            navTriggerOpen();
        }

    });

    routeSearchForm.submit(function (evt) {
        evt.preventDefault();
        document.activeElement.blur();
        startRouting();
    });


// POPUP SEARCH


    navSearch.click(function () {
        if ($(this).hasClass('clicked')) {
            navSearchClose();

        } else {
            navTriggerClose();
            directionsClose();
            //optionsClose();
            navSearchOpen();
        }
    });

    navContent.click(function () {
        navTriggerClose(navTrigger);
    });

    $('.geocodeBox').typeahead({
        minLength: 1,
        highlight: true
    },
    {
        name: 'my-dataset',
        source: findPlace,
        displayKey: function (sugg) {
            if (sugg.vicinity) {
                return sugg.title + ' ' + sugg.vicinity.split('<br/>').join(", ");
            } else {
                return sugg.title;
            }
        },
        templates: {
            suggestion: function (sugg) {
                if (sugg.vicinity) {
                    return '<p class="needsclick">' + sugg.title + ' ' + sugg.vicinity.split('<br/>').join(", ") + '</p>';
                } else {
                    return '<p class="needsclick">' + sugg.title + '</p>';
                }
            }
        }
    });
    $('.geocodeBox').bind('typeahead:selected',
            function (evt, place) {
                $(evt.target).typeahead('close');
                $(evt.target).data('coords', place.position[0] + ',' + place.position[1]);
            });
    $('.geocodeBox').bind('typeahead:autocompleted',
            function (evt, place) {
                $(evt.target).typeahead('close');
                $(evt.target).data('coords', place.position[0] + ',' + place.position[1]);
            });

    $('.geocodeBox').keyup(function () {
        var box = $(this);
        geocode(box.val(), function (result) {
            try {
                var coords = result.Response.View[0].Result[0].Location.DisplayPosition.Latitude + ',' + result.Response.View[0].Result[0].Location.DisplayPosition.Longitude;
                box.data('coords', coords);
            } catch (e) {
                //do nothing
            }
        });
    });

    $('.notice').on('click', function() {
        $(this).hide();
    });
});
function navTriggerOpen() {
    directionsClose();
    navTrigger.addClass('clicked');
    navContent.addClass('open').css('left', '0');
}

function navTriggerClose() {
    navTrigger.removeClass('clicked');
    navContent.removeClass('open').css('left', '-100%');
}

function navSearchOpen() {
    directionsClose();
    navSearch.addClass('clicked');
    $('.popup.route').fadeIn('350');
}

function navSearchClose() {
    navSearch.removeClass('clicked');
    $('.popup.route').fadeOut('350');
}



